import styled from 'styled-components';

// istanbul ignore next
export const StyledOpenDealRoot = styled.div`
    padding: 0;
    margin: 0 auto;
`;

export const StyledOpenDealActivity = styled.div`
    max-width: 935px;
    display: flex;
    gap: 32px;
    flex-direction: column;
    margin: 0 auto;
    padding: 32px 0;

    @media (max-width: 935px) {
        margin: 0 1rem;
    }
`;

export const OpenDealHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const OpenDealCardInfo = styled.div`
    margin-top: 8px;
    color: ${({ theme }) => theme.tokens.BaseColorGray900};
    line-height: 18px;
`;

// Accordion related styles for Vehicle Picker, Customer Card, and Dealership Selector components
export const StyledAccordionContainer = styled.div`
    .custom-accordion {
        height: 100%;
        background: ${({ theme }) => theme.tokens.BaseColorGray50};
        border: ${({ theme }) => `1px solid ${theme.tokens.BaseColorGray300}`};
        border-radius: 4px;
        margin: 0;
        .custom-accordion-summary {
            .MuiAccordionSummary-root {
                padding: 16px;
                align-items: flex-start;
            }
        }
        .custom-accordion-summary-hide-icon {
            .MuiAccordionSummary-root {
                padding: 16px;
                align-items: flex-start;
            }
            .MuiAccordionSummary-expandIconWrapper {
                display: none;
            }
            &:focus {
                outline: none;
            }
        }
        .MuiBox-root {
            &:hover {
                background-color: transparent;
            }
        }
        .change-vehicle-footer-grid {
            background: ${({ theme }) => theme.tokens.BaseColorGray50};
        }
        .MuiInputLabel-root {
            white-space: nowrap;
        }
    }
`;

export const AccordionHeaderContent = styled.div`
    background: ${({ theme }) => theme.tokens.BaseColorWhite};
    padding: 14px;
    margin-top: 8px;
`;

export const StyledAccordionHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
`;

export const StyledAccordionTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
    .editToggle {
        color: ${({ theme }) => theme.tokens.BaseColorBlue600};
    }
`;

export const StyledLoadingContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledAccordionHeaderTitleContainer = styled.div`
    display: flex;
    gap: 0.5rem;
`;
